import React, { useEffect, useState } from "react";
import logo from "../../resource/7.png";
import axios from "axios";
import Swal from "sweetalert2";
import CommonFormFields from "./CommonFormFields";
import apiClient from "@/api/client";

const HomeRequestFormParitta = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    wtNumber: "",
    email: "",
    date: "",
    time: "",
    count: "",
    option: "",
    birthday: false,
    business: false,
    warming: false,
    sick: false,
    exams: false,
    aniversary: false,
    weddings: false,
    mums: false,
    newBorn: false,
    ip_address: "",
  });
  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // Error state

  // Fetch IP address on component mount
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.firstName))
      newErrors.firstName = "First Name should contain only letters, spaces, or hyphens";

    // Validate Last Name
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.lastName))
      newErrors.lastName = "Last Name should contain only letters, spaces, or hyphens";

    // Validate Mobile Number
    if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required";
    else if (!/^\d{10}$/.test(formData.mobileNumber))
      newErrors.mobileNumber = "Mobile Number should be 10 digits";

    // Validate Email
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    // Validate WhatsApp Number
    if (!formData.wtNumber) newErrors.wtNumber = "WhatsApp Number is required";
    else if (!/^\d{10}$/.test(formData.wtNumber))
      newErrors.wtNumber = "WhatsApp Number should be 10 digits";

    // Validate Date
    if (!formData.date) newErrors.date = "Date is required";

    // Validate Time
    if (!formData.time) newErrors.time = "Time is required";

    // Validate Count
    if (!formData.count) newErrors.count = "Number of Sanga members is required";
    else if (!/^\d+$/.test(formData.count) || parseInt(formData.count) <= 0)
      newErrors.count = "Please enter a valid positive number";

    setErrors(newErrors); // Set errors
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return; // Stop execution if validation fails
    }

    setLoading(true); // Set loading state

    try {
      // Map form data to API field names
      const apiData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_number: formData.mobileNumber,
        whatsapp_number: formData.wtNumber,
        email_address: formData.email,
        date: formData.date,
        time: formData.time,
        sanga_members_count: parseInt(formData.count),
        birthday: formData.birthday,
        new_business: formData.business,
        house_warming: formData.warming,
        sick_in_need: formData.sick,
        exams: formData.exams,
        wedding_anniversary: formData.aniversary,
        weddings: formData.weddings,
        pregnant_mums: formData.mums,
        new_born: formData.newBorn,
        other_event: formData.option || null,
        ip_address: formData.ip_address,
      };

      // Submit form data to API
      const response = await apiClient.post('/create-paritta-at-home-requests',
        apiData
      );

      console.log("Form submitted successfully:", response.data);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        mobileNumber: "",
        wtNumber: "",
        email: "",
        date: "",
        time: "",
        count: "",
        option: "",
        birthday: false,
        business: false,
        warming: false,
        sick: false,
        exams: false,
        aniversary: false,
        weddings: false,
        mums: false,
        newBorn: false,
        ip_address: formData.ip_address, // Keep the IP address
      });
      setErrors({}); // Clear errors
    } catch (error) {
      console.error("Error submitting form:", error);

      // Handle API errors
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }

      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="form-page dark-gold ">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Paritta at Home Request Form</h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Please fill in the following details and we will contact you.
        </p>

        <CommonFormFields
          formData={formData}
          handleInputChange={handleInputChange}
          errors={errors}
        />

        <p className="font-p mt-5">
          Please indicate the date and time you wish to have the Paritta Sermon{" "}
        </p>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              min={new Date().toISOString().split('T')[0]} // Set min to today's date
            />
            <label htmlFor="date">Date</label>
            {errors.date && <span className="error">{errors.date}</span>}
          </div>
          <div className="form-item">
            <input
              type="time"
              id="time"
              name="time"
              value={formData.time}
              onChange={handleInputChange}
            />
            <label htmlFor="time">Time</label>
            {errors.time && <span className="error">{errors.time}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate how many Sanga members you would wish to invite.{" "}
        </p>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="number"
              id="count"
              name="count"
              value={formData.count}
              onChange={handleInputChange}
              min="1"
              placeholder="Number of members"
            />
            {errors.count && <span className="error">{errors.count}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate if you have any specific event or purpose for the
          blessings
        </p>

        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="birthday"> Birthday</label>
            <input
              type="checkbox"
              id="birthday"
              name="birthday"
              className="checkbox"
              checked={formData.birthday}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="business"> New Business</label>
            <input
              type="checkbox"
              id="business"
              name="business"
              className="checkbox"
              checked={formData.business}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="warming"> House Warming</label>
            <input
              type="checkbox"
              id="warming"
              name="warming"
              className="checkbox"
              checked={formData.warming}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="sick">Sick in Need</label>
            <input
              type="checkbox"
              id="sick"
              name="sick"
              className="checkbox"
              checked={formData.sick}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="exams">Exams</label>
            <input
              type="checkbox"
              id="exams"
              name="exams"
              className="checkbox"
              checked={formData.exams}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="aniversary">Wedding Anniversary</label>
            <input
              type="checkbox"
              id="aniversary"
              name="aniversary"
              className="checkbox"
              checked={formData.aniversary}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="weddings">Weddings</label>
            <input
              type="checkbox"
              id="weddings"
              name="weddings"
              className="checkbox"
              checked={formData.weddings}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="mums">Pregnant Mums</label>
            <input
              type="checkbox"
              id="mums"
              name="mums"
              className="checkbox"
              checked={formData.mums}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="newBorn">New Born</label>
            <input
              type="checkbox"
              id="newBorn"
              name="newBorn"
              className="checkbox"
              checked={formData.newBorn}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item1">
            <label htmlFor="#">Other (Please specify)</label>
            <input
              type="text"
              id="option"
              name="option"
              value={formData.option}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-5 pb-4">
          Thank you for your kind support. We will be in touch with you shortly.
        </p>
      </form>
    </div>
  );
};

export default HomeRequestFormParitta;